import * as Sentry from '@sentry/browser';


export function errorlog(error, errorInfo, componentName, hasCrashed=false) {
       let sentryId = Sentry.lastEventId();
       Sentry.withScope(scope => {
              scope.setLevel(hasCrashed ? Sentry.Severity.Fatal : Sentry.Severity.Error);
              scope.setTag("Component", componentName);
              scope.setContext("Error Info", {'info': errorInfo});
              sentryId = sentryId ? sentryId : Sentry.lastEventId();
              Sentry.captureException(error);
       });
       return sentryId || Sentry.lastEventId();
}


// WEBPACK FOOTER //
// ./src/helpers/ErrorLogService.js